import React from 'react';
import { motion } from 'framer-motion';
const pains = [{
  icon: '😰',
  text: 'Te quedás sin ideas frente a la IA'
}, {
  icon: '📉',
  text: 'Tus diseños se ven bien… pero no venden'
}, {
  icon: '⏰',
  text: 'Perdés horas probando prompts sin resultados'
}, {
  icon: '😓',
  text: 'No sabés qué estilos o nichos funcionan'
}, {
  icon: '🎯',
  text: 'No tenés un sistema para crear de forma consistente'
}, {
  icon: '📄',
  text: 'Tus diseños no están pensados para producción real'
}, {
  icon: '🔥',
  text: 'Dependés de inspiración para crear'
}, {
  icon: '💸',
  text: 'Querés monetizar con diseños pero no sabés cómo'
}];
export function PainPoints() {
  return <section className="py-12 md:py-20 bg-neutral-900/50 border-y border-neutral-800/50 relative overflow-hidden" data-id="element-67">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-brand-900/10 blur-[100px] pointer-events-none" data-id="element-68" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-69">
        <div className="text-center mb-8 md:mb-16" data-id="element-70">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-bebas text-4xl md:text-6xl text-white uppercase tracking-wide mb-4" data-id="element-71">
            Esto es para vos <span className="text-brand-500" data-id="element-72">si...</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-neutral-400" data-id="element-73">
            ¿Te sentís identificado con alguna de estas situaciones?
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 max-w-4xl mx-auto mb-8 md:mb-12" data-id="element-74">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-neutral-950/80 border border-neutral-800 p-5 rounded-lg flex items-start gap-4" data-id="element-75">
              <span className="text-2xl shrink-0" data-id="element-76">{pain.icon}</span>
              <p className="text-neutral-300 font-medium leading-tight pt-1" data-id="element-77">
                {pain.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-brand-500/10 border border-brand-500/30 rounded-xl p-6 text-center" data-id="element-78">
          <p className="text-xl md:text-2xl font-semibold text-white" data-id="element-79">
            ✅ Si te identificás con al menos una,{' '}
            <span className="text-brand-500" data-id="element-80">
              Prompt Wear fue hecho para vos.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}